/*
/!\
- Please keep in sync with the same file in lrqdo/corpo
- This needs to be called before pageload and not in a setTimeout:
  http://stackoverflow.com/questions/31289530/load-ios-smart-app-banner-through-javascript
*/

import uri from 'URIjs';

const LOCALES_IN_APP_STORE = ['fr', 'en'];
const COUNTRIES_IN_APP_STORE = ['fr', 'be', 'uk'];

function removeAppStoreBanner(userAgent, url) {
    const isIPad = /iPad/.test(userAgent);

    const path = uri(url).path();
    const isLocaleInAppStore = LOCALES_IN_APP_STORE.some(locale => path.indexOf(locale) === 1);

    const removeSecondLevelDomain = true; // .co is a SLD in .co.uk
    const country = uri(url).tld(removeSecondLevelDomain);
    const isCountryInAppStore = COUNTRIES_IN_APP_STORE.indexOf(country) !== -1 || country === ''; // In development, localhost OR IPs have no tld

    if (isIPad || !isLocaleInAppStore || !isCountryInAppStore) {
        const meta = document.querySelector('meta[name=apple-itunes-app]');
        meta.parentNode.removeChild(meta);
    }
}

export { removeAppStoreBanner as default, removeAppStoreBanner };
